import {deepCopy} from "@/lib/utils.js";

let pageDict

function initMenuNode(node,state,acm){
  // 检查权限
  let childrenAcm
  if(node.rule){
    if(!acm){return}
    childrenAcm = acm[node.rule]
    if(!childrenAcm){return}
  }

  if(node.children){
    let children = []
    node.children.forEach((child)=>{
      let child_ = initMenuNode(child,state,childrenAcm)
      if(child_){children.push(child_)}
    })
    if(children.length > 0){
      node.children = children
      return node
    }
  }
  else{
    pageDict[node.name] = node
    return node
  }
}

/**
 * 根据权限初始化菜单
 * @param {Array} menuList 菜单定义对象
 * @param {Function} acm 获取权限map的方法
 * */
export function initMenu(menuList,acm){

  // console.log(acm)

  let state = {key:0}
  let root = {
    children:deepCopy(menuList),
    path:"",
    rule:"root",
  }
  pageDict = {}
  let outMenu = initMenuNode(root,state,{root:acm})
  return outMenu? outMenu.children : []
}

// 处理tree型数据
export function getCurPage(pageName){
  if(!pageDict){return false}
  return pageDict[pageName]
}

